import { IonLabel } from "@ionic/react";
import { Colors, Icon, ValidationObjectType } from "main";

import msg from "../../string-table";
import styles from "./PasswordValidationField.module.css";

type PasswordValidationFieldProps = {
  validationObject: Array<ValidationObjectType>;
};

export function PasswordValidationField(props: PasswordValidationFieldProps) {
  const { validationObject } = props;

  return (
    <div className={styles.validationContainer} style={{ width: "inherit" }}>
      <IonLabel style={{ fontWeight: "var(--swing-font-medium)" }}>
        {msg("PASSWORD_VALIDATION_FIELD_RESET_PASSWORD_VALIDATION_LABEL")}:
      </IonLabel>
      <ul className={styles.validationList}>
        {validationObject.map((regex, index) => (
          <ValidationItem
            key={index}
            isPasswordValid={regex.isValid}
            validationMessage={regex.message}
          />
        ))}
      </ul>
    </div>
  );
}

type ValidationItemProps = {
  isPasswordValid: boolean;
  validationMessage: string;
};
function ValidationItem(props: ValidationItemProps) {
  const { isPasswordValid, validationMessage } = props;

  return (
    <li
      className={`${isPasswordValid ? styles.validationSuccess : styles.validationFailure} ${styles.validationItem}`}
    >
      <div style={{ display: "flex" }}>
        {validationMessage}{" "}
        {isPasswordValid ? (
          <Icon name="Check" color={Colors.green500} />
        ) : (
          <Icon name="Close" color={Colors.red500} />
        )}
      </div>
    </li>
  );
}

export const ValidationRegex = {
  RESET_VALIDATION_UPPERCASE: "(?=.*[A-Z])",
  RESET_VALIDATION_LOWERCASE: "(?=.*[a-z])",
  RESET_VALIDATION_NUMBER: "(?=.*?[0-9])",
  RESET_VALIDATION_MIN_CHARACTERS: ".{8,}",
} as const;
